import R from "ramda";
import { http } from "./http";

export const fetchCurrencies = (accountId) => (
  http.get(`/accounts/${accountId}/currencies`)
    .then(response => {
      const currencies = R.pathOr([], ["data", "supported"], response);
      return { response, currencies };
    })
);



// WEBPACK FOOTER //
// ./src/js/api/currencies.js